import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import Alert from "../IME/Alert";
import IMEAltLogo from "../IME/IMEAltLogo";
import GreenLogo from "../Innovators/GreenLogo";

const LoggedInNav = ({
  profile,
  isAuthenticated,
  user,
  setShowDonate,
  onSubmit,
  setprofileDropDown,
  profileDropDown,
  setShowMenu,
  showMenu,
  email,
  onChange,
  password,
  logout,
}) => {
  let passwordLength = password.split("");

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        {!isAuthenticated && (
          <form
            className="main"
            method="POST"
            onSubmit={(e) => {
              onSubmit(e);
              setprofileDropDown(false);
            }}
          >
            <div className="action-items-index hidden-container-large">
              <div
                className="action-button-index green"
                onClick={() => {
                  if (!showMenu && !profileDropDown) {
                    setShowMenu(true);
                  } else if (profileDropDown) {
                    setprofileDropDown(false);
                    setShowMenu(false);
                  } else {
                    setprofileDropDown(false);
                    setShowMenu(false);
                  }
                }}
              >
                <i className="fa-solid fa-bars action-icon-index fa-lg green"></i>
              </div>
            </div>
            <div className="action-items-index hidden-container">
              <div
                className="action-button-index green"
                onClick={() => {
                  if (!profileDropDown) {
                    setprofileDropDown(true);
                  } else {
                    setprofileDropDown(false);
                  }
                }}
              >
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Login</p>
            </div>
            <Link to={`/${profile.channelid}`}>
              <div className="action-items-index green hidden-container-medium">
                <div className="action-button-index green">
                  <i className="fa-solid fa-users-rectangle action-icon-index-community fa-lg green"></i>
                </div>
                <p className="action-text-index green">Community</p>
              </div>
            </Link>
            <div
              onClick={() => setShowDonate(true)}
              className="action-items-index hidden-container-medium"
            >
              <div className="action-button-index green">
                <i className="fa-solid fa-circle-dollar-to-slot action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Donate</p>
            </div>
            {profileDropDown && (
              <div className="profile-drop-down-alternate">
                <div className="profile-drop-container-nav">
                  <div className="label-input">
                    <label htmlFor="email" className="labels green">
                      *Email:
                    </label>
                    {email === "" && <Alert />}
                    <input
                      name="email"
                      className="input-style-nav"
                      type="email"
                      value={email}
                      placeholder="Enter Email Address"
                      onChange={(e) => onChange(e)}
                      tabIndex="2"
                    />
                  </div>
                  <div className="label-input">
                    <label htmlFor="password" className="labels green">
                      *Password:
                    </label>
                    {password === "" && <Alert />}
                    <input
                      name="password"
                      className="input-style-nav"
                      type="password"
                      min={7}
                      maxLength={20}
                      value={password}
                      placeholder="Enter Password"
                      onChange={(e) => onChange(e)}
                      tabIndex="2"
                    />
                    {email !== "" &&
                      password !== "" &&
                      passwordLength.length >= 7 &&
                      passwordLength.length <= 20 && (
                        <div className="login-button-container-alt">
                          <button
                            className="login-button-alt background-green"
                            type="submit"
                          >
                            Login
                          </button>
                        </div>
                      )}
                    <Link to="/forgotpassword">
                      <p className="forgot green" tabIndex="4">
                        Forgot Password?
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </form>
        )}
        {isAuthenticated && (
          <div className="user-container">
            <div className="user-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  user && user.avatar
                }`}
                className="user-avi"
              />
            </div>
            <div className="user-name-info-container">
              <p className="user-name-info"> Hi, {user && user.firstname}!</p>
              <div className="arrows-up-down">
                {!profileDropDown && (
                  <i
                    className={`fas fa-angle-up mx-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : "blue"
                    }`}
                    onClick={() => setprofileDropDown(true)}
                  ></i>
                )}
                {profileDropDown && (
                  <i
                    className={`fas fa-angle-down mx-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : "blue"
                    }`}
                    onClick={() => setprofileDropDown(false)}
                  ></i>
                )}
              </div>
            </div>
            {profileDropDown && isAuthenticated && (
              <div className="campaign-profile-drop-down">
                {user.channelid === "roland" && (
                  <Link to="/liveonime/roland/live">
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-tower-broadcast fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Stream Manager</p>
                    </div>
                  </Link>
                )}
                {user.channelid === "roland" && (
                  <Link to="/home">
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-home fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Production Homepage</p>
                    </div>
                  </Link>
                )}
                {user.channelid === "roland" && (
                  <Link to="/roland/dashboard">
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-chart-simple fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Dashboard</p>
                    </div>
                  </Link>
                )}
                <div
                  onClick={() => {
                    setprofileDropDown(false);
                    setShowDonate(true);
                  }}
                  className="profile-drop-container"
                >
                  <i
                    className={`fa-solid fa-circle-dollar-to-slot drop-down-icon ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : "blue"
                    }`}
                  ></i>
                  <p className="drop-down-text">Donate</p>
                </div>
                <Link to={`/${profile.channelid}`}>
                  <div className="profile-drop-container">
                    <i
                      className={`fa-solid fa-users fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                    ></i>
                    <p className="drop-down-text">Community Posts</p>
                  </div>
                </Link>
                {user && user.role !== "innovator" && (
                  <Link to={`/${user.channelid}/create_job_post`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-suitcase fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Create Job Post</p>
                    </div>
                  </Link>
                )}
                {user && user.role !== "innovator" && (
                  <Link to={`/${user.channelid}/manage_applications`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-suitcase fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Manage Applications</p>
                    </div>
                  </Link>
                )}
                {user.channelid === "roland" && (
                  <Link to={`/jobs`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-suitcase fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Job Posts</p>
                    </div>
                  </Link>
                )}
                {user.channelid === "imeemployer" && (
                  <Link to={`/jobs`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-suitcase fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Job Posts</p>
                    </div>
                  </Link>
                )}
                {user.channelid === "imeinnovator" && (
                  <Link to={`/jobs`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-suitcase fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Job Posts</p>
                    </div>
                  </Link>
                )}
                {user && user.role !== "innovator" && (
                  <Link to={`/${user.channelid}/content`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-photo-film fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Content</p>
                    </div>
                  </Link>
                )}
                {!user.banned && (
                  <Link to={`/${user && user.channelid}/edit`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-regular fa-circle-user fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Edit Profile</p>
                    </div>
                  </Link>
                )}
                <Link to={`/${user && user.channelid}/purchases`}>
                  <div className="profile-drop-container">
                    <i
                      className={`fas fa-dollar-sign fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                    ></i>
                    <p className="drop-down-text">Purchases</p>
                  </div>
                </Link>
                <Link to={`/calendar`}>
                  <div className="profile-drop-container">
                    <i
                      className={`fa-solid fa-calendar-days fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>
                    <p className="drop-down-text">Calendar</p>
                  </div>
                </Link>
                <Link to={`/${user.channelid}/settings`}>
                  <div className="profile-drop-container">
                    <i
                      className={`fas fa-cog fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>
                    <p className="drop-down-text">Settings</p>
                  </div>
                </Link>
                <Link to="/agreement">
                  <div className="profile-drop-container">
                    <i
                      className={`fa-solid fa-file-contract fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                    ></i>
                    <p className="drop-down-text">Terms of Agreement</p>
                  </div>
                </Link>
                <div
                  className="profile-drop-container"
                  onClick={() => {
                    logout();
                    setprofileDropDown(false);
                  }}
                  href="#!"
                >
                  <i
                    className={`fas fa-door-closed fa-lg drop-down-icon ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : "blue"
                    }`}
                  ></i>
                  <p className="drop-down-text">Logout</p>
                </div>
              </div>
            )}
            <div
              onClick={() => setShowDonate(true)}
              className="action-items-index hidden-container"
            >
              <div className="action-button-index green">
                <i className="fa-solid fa-circle-dollar-to-slot action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Donate</p>
            </div>
          </div>
        )}
        {showMenu && !isAuthenticated && (
          <div className="campaign-profile-drop-down-alt">
            <div
              onClick={() => {
                if (!profileDropDown) {
                  setShowMenu(false);
                  setprofileDropDown(true);
                } else {
                  setprofileDropDown(false);
                }
              }}
              className="profile-drop-container"
            >
              <i className={`fa-solid fa-user fa-lg drop-down-icon green`}></i>
              <p className="drop-down-text">Login</p>
            </div>
            <div
              onClick={() => {
                setShowMenu(false);
                setShowDonate(true);
              }}
              className="profile-drop-container"
            >
              <i className="fa-solid fa-circle-dollar-to-slot drop-down-icon green"></i>
              <p className="drop-down-text">Donate</p>
            </div>
            <Link to={`/${profile.channelid}`}>
              <div className="profile-drop-container">
                <i
                  className={`fa-solid fa-users fa-lg drop-down-icon green`}
                ></i>
                <p className="drop-down-text">Community Posts</p>
              </div>
            </Link>
            <Link to={`/calendar`}>
              <div className="profile-drop-container">
                <i
                  className={`fa-solid fa-calendar-days fa-lg drop-down-icon green`}
                ></i>
                <p className="drop-down-text">Calendar</p>
              </div>
            </Link>
            <Link to="/agreement">
              <div className="profile-drop-container">
                <i
                  className={`fa-solid fa-file-contract fa-lg drop-down-icon green`}
                ></i>
                <p className="drop-down-text">Terms of Agreement</p>
              </div>
            </Link>
          </div>
        )}
        <Link to="/">
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark green fa-sm mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </Link>
        <div className="buttons hidden-container">
          <Link to="/employers">
            <div className="action-items-index green">
              <div className="action-button-index green">
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Employers</p>
            </div>
          </Link>
          <Link to="/mentors">
            <div className="action-items-index green">
              <div className="action-button-index green">
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
              <p className="action-text-index green">Mentors</p>
            </div>
          </Link>
        </div>
      </nav>
    </Fragment>
  );
};

export default LoggedInNav;
